// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__168wA","imageUploader":"EGiftCard_imageUploader__1Tb96"};